import { alfrescoTypes } from '../constants';
export async function getDictionary(path) {
    return await get("get", path);
}
export async function getAttachmentsDictionary(type) {
    if (type === alfrescoTypes.certificate) {
        return await getDictionary('cm:ISCC-EU_x0020_Certificate/cm:Additional_x0020_Documents/cm:Additional_x0020_Document_x0020_Types');
    }
    else {
        return await getDictionary('cm:Consideration_x0020_And_x0020_Accreditation/cm:Additional_x0020_Documents/cm:Additional_x0020_Document_x0020_Types');
    }
}
async function get(baseUrl, path = null) {
    return await fetch(`dictionary/${baseUrl}?${(!Array.isArray(path) ? (path ? `path=${path}` : "") : "path=" + path.join("&path="))}`,
        { method: 'GET', headers: { 'Content-Type': 'application/json' } })
        .then(res => {
            if (!res.ok) return require('./ModalDialogsTemplates').unknownErrorMessageDialog();
            let result = res.json();
            return result;
        });
}
export async function getDictionaryByName(name) {
    return await fetch(`dictionary/getByName?name=${name}`,
        { method: 'GET', headers: { 'Content-Type': 'application/json' } })
        .then(res => {
            if (!res.ok) return require('./ModalDialogsTemplates').unknownErrorMessageDialog();
            let result = res.json();
            return result;
        });
}
export async function getAdditionalDocumentsStates() {
    return await getDictionaryByName("AdditionalDocumentsStates");
}